/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { AuditEventResponse } from './auditEventResponse';

export interface AuditEventListResponse {
  events: AuditEventResponse[];
  total: number;
  page: number;
  per_page: number;
}
